import { gettext } from "../../shared/utils/legacy";
import cropr from "../../shared/utils/cropr";
import AdmissionStatus from "../AdmissionStatus";
import React from "react";
import DashboardSummaryInfo from "./DashboardSummaryInfo";

export default function DashboardSummaryAdmission() {
  // - 0 waarschuwingen: vinkje
  // - anders x waarschuwingen met uitroepteken
  // - doorklik is toelatingen scherm
  // - toelatingen niet actief > hover: teeltregistratie kopen
  return (
    <div className="col-4 col-md py-3">
      <h6 className="text-muted mb-3">{gettext("Admissions")}</h6>
      {(cropr.features.admissions && <AdmissionStatus />) ||
        (cropr.features.pro && (
          <a
            href={"/cropr/settings/apps/#admissions"}
            className="text-black js-log-metric"
            data-metrics_category="summary_widget"
            data-metrics_sub_category="install_admission"
          >
            {gettext("Install app")}
          </a>
        )) || <DashboardSummaryInfo category="teeltregistratie" />}
    </div>
  );
}
